import React, { useCallback, useEffect, useReducer, useState } from 'react'
import { Button, Col, FormGroup, ListGroup, Modal, Row } from 'react-bootstrap'
// import { Link } from "react-router-dom";
import moment from 'moment'
import { padLeft } from './FullCalendar'
import { Checkbox } from '@mui/material'
import { createOrderAuth } from '../_redux/calendarCrud'
import {
    authSwal,
    checkAuthCheckBoxSwal,
    checkAuthInputSwal,
    checkAuthPhoneSwal,
    checkAuthPickUpDtmSwal,
} from '../../../../util/Swals'
import { WORK_TYPE_ORDER, WORK_TYPE_BOOKN } from '../../Wizard/WizardConstants'

const initialState = {
    store_identifier: '',
    pickup_dtm: '',
    phone_number: '',
    buyer_name: '',
    check: false,
}

export const CHANGE_AUTH_DATA = 'CHANGE_AUTH_DATA'
export const SET_ORDER_AUTH = 'SET_ORDER_AUTH'
export const RESET_ORDER_AUTH = 'RESET_ORDER_AUTH'

const reducer = (state, action) => {
    switch (action.type) {
        case CHANGE_AUTH_DATA: {
            // const auth = {...state}
            // auth[action.name] = action.value;
            // console.log(auth)
            const value = action.name === 'check' ? action.check : action.value

            return {
                ...state,
                [action.name]: value,
            }
        }
        case SET_ORDER_AUTH: {
            return {
                ...state,
                pickup_dtm: action.pickup_dtm,
            }
        }
        case RESET_ORDER_AUTH: {
            return {
                ...state,
                pickup_dtm: '',
                phone_number: '',
                buyer_name: '',
                check: false,
            }
        }
        default:
            throw new Error()
    }
}

export function CalendarModal({ show, onHide, storeConfs, data, selectedDate, store }) {
    const [state, dispatch] = useReducer(reducer, initialState)
    const [pickup_dtm, setPickup_dtm] = useState()
    const authRedirect = storeConfs.find(item => item.key === "AUTH_REDIRECT")
    const workType = storeConfs.find(item => item.key === "WORK_TYPE") || "ORDER"
    const typeName = workType.value === "ORDER" ? WORK_TYPE_ORDER:WORK_TYPE_BOOKN

    useEffect(() => {
        setPickup_dtm(undefined)
        return () => {
            dispatch({ type: RESET_ORDER_AUTH })
        }
    }, [selectedDate])

    const filterEvent = useCallback(
        (currentSlot, _storeConfs) => {
            const eventArray = []
            const storeConfs = _storeConfs
            if (data) {
                // data 는 선택한 날짜에 '휴무일', '출강', '마감', '오전/오후 마감' 등의 데이터가 들어있음. 
                // 일반적으로 1개의 데이터가 들어있음.
                data.forEach((event, i) => {
                    // 여기서는 '시간 마감' 에 대한 이벤트가 만들어지고, 
                    const eventHHMM = moment(event.start).hours() * 100 + moment(event.start).minutes()
                    if (currentSlot === eventHHMM) {
                        eventArray.push(event)
                    }

                    // 여기서 만들어지는 '오전/오후 마감' 이벤트가 만들어짐.
                    if (event.title === '오전 마감' || event.title === '오후 마감') {
                        const workBreak = (storeConfs.WORK_BREAK ?? '1300') * 1
                        // console.log('workBreak[' + workBreak + ']')
                        if (event.title === '오전 마감') {
                            if (currentSlot <= workBreak) eventArray.push(event)
                        } else if (event.title === '오후 마감') {
                            if (currentSlot >= workBreak) eventArray.push(event)
                        }
                    }
                })
            }
            return eventArray
        },
        [data]
    )

    const eventList = useCallback(() => {
        const timeSlots = []
        const _storeConfs = []

        if (storeConfs.length > 1) {
            storeConfs.forEach((item) => {
                _storeConfs[item.key] = item.value
            })

            const toMinutes = (hhmm) => Math.floor(hhmm / 100) * 60 + (hhmm % 100)
            const toHHMM = (minutes) => Math.floor(minutes / 60) * 100 + (minutes % 60)
            const intervalMin = _storeConfs.SLOT_INTERVAL * 1
            const endMin = toMinutes(_storeConfs.WORK_END * 1)
            let currentMin = toMinutes(_storeConfs.WORK_START * 1) + intervalMin
            do {
                const hhmm = toHHMM(currentMin)
                timeSlots.push({
                    timeTitle: padLeft(hhmm, 4, '0'),
                    event: filterEvent(hhmm, _storeConfs),
                })
                currentMin += intervalMin
            } while (currentMin <= endMin)
        }

        return timeSlots
    }, [storeConfs, filterEvent])

    const onChange = useCallback(
        (e) => {
            dispatch({
                type: CHANGE_AUTH_DATA,
                name: e.target.name,
                value: e.target.value,
                check: e.target.checked,
            })
        },
        [dispatch]
    )

    const authShow = useCallback(
        (item) => {
            const pickup_dtm =
                item !== undefined &&
                typeof item === 'string' &&
                selectedDate + ' ' + item.substr(0, 2) + ':' + item.substr(2, 2)
            dispatch({ type: SET_ORDER_AUTH, pickup_dtm: pickup_dtm })
            setPickup_dtm(item)
        },
        [dispatch, selectedDate]
    )

    const onOrder = useCallback(() => {
        const auth = { ...state }
        auth.store_identifier = store.store_identifier

        if (auth.buyer_name === '' || auth.phone_number === '') {
            checkAuthInputSwal()
            return false
        } else if (!auth.phone_number.match(/^(010)[0-9]{3,4}[0-9]{4}$/)) {
            checkAuthPhoneSwal()
            return false
        } else if (!auth.check) {
            checkAuthCheckBoxSwal()
            return false
        } else if (!auth.pickup_dtm) {
            checkAuthPickUpDtmSwal(workType.value)
            return false
        }

        const dateSplit = auth.pickup_dtm.split(' ')[0]
        const dateSplit2 = auth.pickup_dtm.split(' ')[1]

        const dateStr =
            dateSplit + 'T' + dateSplit2.split(':')[0] + ':' + dateSplit2.split(':')[1] + ':00Z'

        auth.pickup_dtm = new Date(dateStr)

        createOrderAuth(auth)
            .then((res) => {
                const result = res.data
                if (!!result) {
                    onHide()
                    dispatch({type: RESET_ORDER_AUTH})
                    setPickup_dtm(null)

                    if(undefined === authRedirect || "true" === authRedirect.value) {
                        authSwal(workType.value)
                        /* 카카오톡 화면 닫기 */
                        var _ua = window.navigator.userAgent || window.navigator.vendor || window.opera
                        if (_ua.toLocaleLowerCase().indexOf('kakaotalk')) {
                            window.location.href = /iPad|iPhone|iPod/.test(_ua)
                                ? 'kakaoweb://closeBrowser'
                                : 'kakaotalk://inappbrowser/close'
                        }
                    }else {
                        // redirect
                        window.location.href = '/k/' + result?.data
                    }
                }
            })
            .catch((err) => console.error(err))
    }, [state, onHide, dispatch, store, authRedirect, workType])

    return (
        <Modal
            show={show}
            onHide={onHide}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
            autoFocus={false}
            animation={false}
            enforceFocus={false}
            restoreFocus={false}
            scrollable={false}
        >
            <Modal.Header closeButton>
                <Modal.Title id='contained-modal-title-vcenter'>
                    <p className='mb-0'>{selectedDate}</p>
                    {/*<p className="small mb-0">픽업날짜를 선택해주세요.</p>*/}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xl={6}>
                        <ListGroup
                            className='flex-row flex-wrap h-100' /*style={{height:300, overflow:"scroll"}}*/
                        >
                            {' '}
                            {eventList().map((item, idx, arr) => {
                                // console.log('item [' + JSON.stringify(item) + ']')
                                return (
                                    <ListGroup.Item
                                        // variant={idx % 2 === 0 ? 'secondary' : 'light'}
                                        variant='secondary' // 20240104 : 지혜네 케이크 수정요청, 시간 테이블 색상 통일
                                        active={item.timeTitle === pickup_dtm}
                                        key={'eventList-' + idx}
                                        style={{ flexBasis: '33%', borderRadius: 'inherit', borderTopWidth: 'thin' }}
                                        onClick={() => { if (item.event.length === 0) authShow(item.timeTitle) }}
                                    >
                                        {item.timeTitle.substr(0, 2) + ':' + item.timeTitle.substr(2, 2)}
                                        {item.event.map((event, i) => (
                                            <span className={'font-weight-bold'}>&nbsp;마감</span>
                                        ))}
                                    </ListGroup.Item>
                                )
                            })}
                        </ListGroup>
                    </Col>
                    <Col xl={6}>
                        <form>
                            <FormGroup>
                                <label>이름</label>
                                <input
                                    type='text'
                                    className='form-control form-control-solid'
                                    name='buyer_name'
                                    placeholder='이름'
                                    onChange={onChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>
                                    전화번호 <small>'-' 없이 숫자만 입력해주세요.</small>
                                </label>
                                <input
                                    type='text'
                                    className='form-control form-control-solid'
                                    name='phone_number'
                                    placeholder='01012345678'
                                    onChange={onChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Checkbox name='check' onChange={onChange} />
                                <label>개인정보활용에 동의합니다.</label>
                                <a
                                    href={'/privacy'}
                                    style={{ marginLeft: '5px' }}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    [상세보기]
                                </a>
                            </FormGroup>
                        </form>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onOrder}>{(undefined === authRedirect || "true" === authRedirect.value) ? typeName + ' 링크 전송' : '다음'}</Button>
                <Button onClick={onHide} className='btn-light'>
                    닫기
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
